import AuthService, { authServiceInstance } from "./AuthService";
import RequestService from "./libs/RequestService";

export abstract class DataService {
  protected readonly authService: AuthService;
  protected readonly requestService: RequestService;

  constructor() {
    // initialize AuthService
    this.authService = authServiceInstance;
    // get RequestService with auth header
    this.requestService = authServiceInstance.getAuthenticatedRequestService();
  }
}
